import "../../../../src/Components/Inmobiliarias/Perfil/styles.less";

import { Affix, Col, Row } from "antd";
import {
	BannerAffix,
	BannerTopCover,
	PerfilBreadcrumb,
	PerfilButtonContacts,
	PerfilInfoInmob,
	PerfilProperties,
	PerfilSubsidiary,
} from "../../../../src/Components/Inmobiliarias/Perfil/perfilComponents";
import React, { useEffect } from "react";

import { PageLayout } from "../../../../src/Components/Layout/web";
import { PerfilSkeleton } from "../../../../src/Components/Inmobiliarias/Perfil/perfilSkeleton";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useRealEstateSingle } from "../../../../src/Components/Inmobiliarias/Perfil/hook";
import { useRouter } from "next/router";
import { useTheme } from "../../../../shared-components/Styles/ThemeHook";
import { withApollo } from "../../../../lib/apollo3";
import { withAuth } from "../../../../lib/auth";
import { withContext } from "../../../../lib/context";
import { withGlobalComponents } from "../../../../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../../../../shared-components/i18n";

// Page Perfil
const Perfil = () => {
	const { theme } = useTheme();
	const screen = useBreakpoint();
	const { inmob, loading, error, contact, inmobId } = useRealEstateSingle();
	const router = useRouter();

	useEffect(() => {
		if (!loading && !inmob) {
			router.push("/inmobiliarias");
		} else if (inmob && router.asPath !== inmob?.profile_url) {
			router.replace(
				{
					pathname: "/infocasas/inmobiliarias/perfil/[perfil_id]",
					query: { perfil_id: inmobId },
				},
				inmob?.profile_url,
				{ shallow: true }
			);
		}
	}, [loading, inmob]);

	if (error) return null;
	if (loading || !inmob) return <PerfilSkeleton />;

	return (
		<PageLayout classContainer="perfil-inmob-container">
			{/* Banner Top Cover */}
			{!screen.xs && <BannerTopCover inmob={inmob} />}
			{/* Content */}
			<div className="content-container">
				<Affix className="perfil-fidex-top" offsetTop={theme.headerHeight}>
					<div className="container">
						{/* Banner Affix */}
						<BannerAffix inmob={inmob} />
					</div>
				</Affix>
				<div className="perfil-content">
					<Row
						gutter={[0, theme.spacing.xlSpacing]}
						style={{
							padding: `${theme.spacing.xlSpacing}px 0`,
						}}>
						{/* Breadscrum */}
						<Col span={24}>
							<div className="container">
								<PerfilBreadcrumb inmob={inmob} />
							</div>
						</Col>
						{/* Info Real Estate */}
						<Col span={24}>
							<div className="container">
								<PerfilInfoInmob inmob={inmob} />
							</div>
						</Col>
						{/* Subsidiary */}
						<Col span={24}>
							<div className="container">
								<PerfilSubsidiary inmob={inmob} />
							</div>
						</Col>
						{/* Properties */}
						<Col span={24}>
							<div className="container">
								<PerfilProperties inmob={inmob} />
							</div>
						</Col>
						{/* Buttons Bottom Contact */}
						<Col span={24}>
							<div className="container">
								<PerfilButtonContacts inmob={inmob} contact={contact} />
							</div>
						</Col>
					</Row>
				</div>
			</div>
			<style jsx global>{`
				.perfil-fidex-top {
					background: ${inmob?.color};
				}

				.perfil-fidex-top .ant-affix {
					background: #fafafa;
					background: ${inmob?.color};
				}
			`}</style>
		</PageLayout>
	);
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(Perfil))), {
		withDummyContext: false,
		withFiltersContext: false,
		withConfigContext: true,
		withThemeContext: true,
	})
);
